import { GlobalFilterObject } from '@type/filters';
import {
  Button, Dropdown, DropdownButton, DropdownItems, DropdownItem,
} from '@components/common';
import { useTranslation } from 'next-i18next';
import { ArrowUturnUpIcon, ChevronDownIcon } from '@heroicons/react/16/solid';
import { filterStyles } from '../helpers/filterStyles';


// Interfaces
// **************************************
interface TopBarDropdownSuggestionProps {
  data: GlobalFilterObject,
  label: string,
  applySuggestion: (param: object) => void,
}


/**
 * @description The top bar dropdown suggestion component. It shows a list of suggested filters in a dropdown.
 * - **data** The data object with the suggested filters. Use the appropriate filter object from the helpers.
 * - **label** The label of the dropdown.
 * - **applySuggestion** The function to apply the suggestion.
 */
export const TopBarDropdownSuggestion = (props: TopBarDropdownSuggestionProps) => {
  // Destructure props
  const {
    data,
    label,
    applySuggestion,
  } = props;

  // Translation
  const { t } = useTranslation('common');

  // Render component
  // **************************************
  return (
    <Dropdown>
      {/* Toggle */}
      <DropdownButton
        as={Button}
        styling="none"
        className={filterStyles.suggestionButton}
      >
        <ArrowUturnUpIcon className={`${filterStyles.suggestionButtonIcon} size-4`} />
        {t(label)}
        <ChevronDownIcon className="-mx-0.5 size-4" />
      </DropdownButton>

      {/* Items */}
      <DropdownItems
        animation="slideDown"
        anchor="bottom"
        className={`${filterStyles.listboxOptionsWrapper} py-2`}
      >
        {data?.fields.map((field) => (
          <DropdownItem
            key={field?.label}
            as={Button}
            styling="none"
            onClick={() => applySuggestion({ [data?.apiParameter]: field?.recordOptions?.defaultValue })}
            className={`${filterStyles.listboxOption} w-full`}
          >
            {t(field?.label)}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};
